var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.show
      ? _c(
          "div",
          {
            staticClass: "modern-update-overlay",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.close.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "modern-update-card" }, [
              _c("div", { staticClass: "update-header" }, [
                _c("div", { staticClass: "sparkle-icon" }, [_vm._v("✨")]),
                _vm._v(" "),
                _c("h3", [
                  _vm._v(
                    "تحديثات النظام الجديدة (" + _vm._s(_vm.version) + ")"
                  ),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("أحدث التحسينات والمميزات التي تم إضافتها")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "update-body" },
                _vm._l(_vm.recentUpdates, function (update, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "feature-item" },
                    [
                      _c("div", { staticClass: "feature-bullet" }, [
                        _vm._v(_vm._s(update.icon)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "feature-content" }, [
                        _c("h4", [_vm._v(_vm._s(update.title))]),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "update-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-view-all",
                    on: { click: _vm.viewAllUpdates },
                  },
                  [_vm._v("\n          📋 عرض كافة التفاصيل\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "btn-got-it", on: { click: _vm.close } },
                  [_vm._v("إغلاق")]
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }